module.exports = __webpack_public_path__ + "static/media/icon-whole-home.0efcb90d.svg";